<template>
  <div class="entry-certificate">
    <div class="row" style="margin-bottom: 9px">
      <van-image class="logo" :src="imageView(match.icon)" fit="cover" round />
    </div>
    <div class="row" style="margin-bottom: 10px">
      <span class="group-name">{{ match.chineseName }}</span>
    </div>
    <div class="row" style="margin-bottom: 15px">
      <div style="display: flex; align-items: center;">
        <van-image v-if="match.status === 0" :src="finish" fit="contain" style="width: 50px; height: 19px; margin-right: 10px"/>
        <span style="font-size: 14px; color: #FFFFFF">{{ match.ruleType }}</span>
      </div>
    </div>
    <div class="player">
      <div class="top">
        <div class="point"></div>
      </div>
      <div style="height: 30px;"></div>
      <div class="detail">
        <van-image v-if="player.avatar" class="poster" fit="contain" :src="imageView(player.avatar)"></van-image>
        <van-image v-else class="poster" fit="contain" :src="defaultAvatar"></van-image>
        <div class="player-info">
          <div class="title">球员证</div>
          <div class="detail-row">
            <div class="key">姓名</div>
            <div class="value">{{ player.trueName ? player.trueName : '--' }}</div>
          </div>
          <div class="detail-row">
            <div class="key">球衣</div>
            <div class="value">{{ player.number ? player.number : '--' }}</div>
          </div>
          <div class="detail-row">
            <div class="key">球队</div>
            <div class="value">{{ team.name ? team.name : '--' }}</div>
          </div>
          <div class="detail-row">
            <div class="key">位置</div>
            <div class="value">{{ player.position ? player.position : '--' }}</div>
          </div>
        </div>
      </div>
      <div style="height: 56px;"></div>
      <div class="qrcode">
        <div class="qrcode-row">
          <div class="line1"></div>
          <div class="line1"></div>
        </div>
        <div class="qrcode-row">
          <div class="line2"></div>
          <div class="line2"></div>
        </div>
        <div id="my-qrcode" style="margin: 0 auto; width: 150px; height: 150px;"></div>
        <div class="qrcode-row">
          <div class="line2"></div>
          <div class="line2"></div>
        </div>
        <div class="qrcode-row">
          <div class="line1"></div>
          <div class="line1"></div>
        </div>
      </div>
      <div style="height: 28px;"></div>
      <div style="display: flex; justify-content: center; align-items: center">
        <div style="margin-right: 9px; border-radius: 2px; overflow: hidden">
          <div style="display: flex; justify-content: space-between">
            <div style="background-color: #3972FE; width: 4px; height: 1px;"></div>
            <div style="background-color: #3972FE; width: 4px; height: 1px;"></div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div style="background-color: #3972FE; width: 1px; height: 3px;"></div>
            <div style="background-color: #3972FE; width: 1px; height: 3px;"></div>
          </div>
          <div style="padding: 2px 1px">
            <div style="background-color: #3972FE; width: 12px; height: 1px;"></div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div style="background-color: #3972FE; width: 1px; height: 3px;"></div>
            <div style="background-color: #3972FE; width: 1px; height: 3px;"></div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div style="background-color: #3972FE; width: 4px; height: 1px;"></div>
            <div style="background-color: #3972FE; width: 4px; height: 1px;"></div>
          </div>
        </div>
        <div style="font-size: 13px; color: #3972FE">扫码检录</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage } from 'vant'
import { QNImageUtil } from "@/utils";
Vue.use(VanImage)
import QRCode from 'qrcodejs2'
import {getPlayerDigitalQualificationCard} from "@/api/match";
export default {
  name: 'entry-certificate',
  data() {
    return {
      matchId: '',
      match: {},
      player: {},
      team: {},
      finish: require('../../../assets/finish.png'),
      defaultAvatar: require('../../../assets/default_avatar.png'),
      playerId: ''
    }
  },
  mounted() {
    this.matchId = this.$route.params.matchId
    this.playerId = this.$route.query.playerId
    this.getPlayerDigitalQualificationCard()
  },
  methods: {
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getPlayerDigitalQualificationCard() {
      const params = {
        matchId: this.matchId,
        playerId: this.playerId
      }
      getPlayerDigitalQualificationCard(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match
          this.player = data.player
          this.team = data.team
          new QRCode('my-qrcode', {
            width: 150,
            height: 150,
            text: `${this.matchId}?playerId=${this.playerId}`
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-certificate {
  min-height: 100vh;
  background-color: #FFFFFF;
  background-image: url("../../../assets/entry-bgi.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding-top: 22px;
  .row {
    display: flex;
    justify-content: center;
    .logo {
      width: 54px;
      height: 54px;
    }
    .group-name {
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 500;
      font-family: PingFang SC Medium;
    }
  }
  .player {
    margin: 0 14px;
    border-radius: 17px;
    background-color: #FFFFFF;
    .top {
      margin: 0 auto;
      width: 99px;
      height: 26px;
      border-radius: 0 0 25px 25px;
      background-color: #D4E0FF;
      display: flex;
      align-items: center;
      justify-content: center;
      .point {
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background-color: #3972FE;
      }
    }
    .detail {
      padding-left: 24px;
      display: flex;
      .poster {
        width: 120px;
        height: 170px;
        border-radius: 5px;
        margin-right: 25px;
      }
      .player-info {
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        .title {
          color: #3972FE;
          font-size: 18px;
          font-weight: bolder;
        }
        .detail-row {
          display: flex;
          .key {
            color: #999999;
            font-size: 16px;
            margin-right: 12px;
          }
          .value {
            color: #323232;
            font-size: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .qrcode {
      width: 174px;
      height: 174px;
      margin: 0 auto;
      .qrcode-row {
        display: flex;
        justify-content: space-between;
        .line1 {
          width: 12px;
          height: 3px;
          background-color: #3972FE;
        }
        .line2 {
          width: 3px;
          height: 9px;
          background-color: #3972FE;
        }
      }
    }
  }
}
</style>
